import {
  curveBasis,
  curveBasisClosed,
  curveBasisOpen,
  curveBundle,
  curveCardinal,
  curveCardinalClosed,
  curveCardinalOpen,
  curveLinear,
  curveLinearClosed,
  curveMonotoneX,
  curveStep,
  curveStepAfter,
  curveStepBefore,
} from 'd3-shape';

const Interpolation = {
  BASIS: curveBasis,
  BASIS_CLOSED: curveBasisClosed,
  BASIS_OPEN: curveBasisOpen,
  BUNDLE: curveBundle,
  CARDINAL: curveCardinal,
  CARDINAL_CLOSED: curveCardinalClosed,
  CARDINAL_OPEN: curveCardinalOpen,
  LINEAR: curveLinear,
  LINEAR_CLOSED: curveLinearClosed,
  MONOTONE: curveMonotoneX,
  STEP: curveStep,
  STEP_AFTER: curveStepAfter,
  STEP_BEFORE: curveStepBefore,
};
export default Interpolation;
